import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import type { ObjectWorkflowMetadata } from "../../api/types/objectTypes";

interface Props {
  workflowMetadata: ObjectWorkflowMetadata[];
}

const ObjectWorkflowFailureAlert = ({ workflowMetadata }: Props) => {
  return (
    <Alert severity="error">
      <AlertTitle>Workflow failed</AlertTitle>
      <Stack spacing={1}>
        {workflowMetadata
          .filter((m) => Boolean(m.failureMessage))
          .map((m) => (
            <Typography key={m.workflowId}>{m.failureMessage}</Typography>
          ))}
      </Stack>
    </Alert>
  );
};

export default ObjectWorkflowFailureAlert;
